export const PAGE_GUIDE_KEYS = {
  RECIPES_DISCOVER: "recipes_discover",
  RECIPES_PUBLIC: "recipes_public",
  RECIPES_PRIVATE: "recipes_private",
  RECIPES_SAVED: "recipes_saved",
  PANTRY: "pantry",
  SHOPPING: "shopping",
  RECIPE_IDEAS: "recipe_ideas",
  MEAL_PLANNER: "meal_planner",
};

export function appendDismissedGuide(onboarding, guideKey) {
  const dismissedPages = Array.isArray(onboarding?.onboarding_dismissed_pages)
    ? onboarding.onboarding_dismissed_pages
    : [];

  if (!guideKey || dismissedPages.includes(guideKey)) {
    return dismissedPages;
  }

  return [...dismissedPages, guideKey];
}
